import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import AccoladeDialog from "./AccoladeDialog";
import DeleteConfirmationDialog from "./DeleteConfirmationDialog";

export default function AthleteAccoladesTab({
  accolades,
  openCreateAccolade,
  openEditAccolade,
  openDeleteAccoladeModal,
  isAccoladeOpen,
  setIsAccoladeOpen,
  isAccoladeEdit,
  handleAccoladeSubmit,
  handleAccoladeSubmission,
  selectedType,
  setValue,
  errors,
  accoladeRegister,
  allStateOptions,
  allConferenceOptions,
  classifications,
  date,
  loading,
  resetAccolade,
  deleteAccoladeOpen,
  setDeleteAccoladeOpen,
  handleAccoladeDeleteConfirm,
}) {
  return (
    <>
      <div className="px-6 -mx-6 overflow-y-auto overflow-x-hidden h-[550px]">
        <div className="p-0 text-gray-700 text-sm">
          <div className="flex items-center justify-between p-0">
            <h2 className="font-medium mb-4 uppercase">Accolades</h2>
            <div
              onClick={openCreateAccolade}
              className="float-right text-sm text-white border border-gray-300 p-2 rounded bg-blue-600 hover:bg-blue-800 cursor-pointer"
            >
              <FontAwesomeIcon icon={faPlus} /> Add new Accolades
            </div>
          </div>
          {Array.isArray(accolades) && accolades.length > 0 ? (
            <div className="mt-3">
              {accolades.map((accolade) => (
                <div
                  key={accolade.id}
                  className="w-full bg-white border border-gray-200 rounded-md p-3 mb-2"
                >
                  <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12 md:col-span-4">
                      <p className="text-sm text-gray-500 mb-0">Description</p>
                      <p className="text-base font-normal text-gray-900">
                        {accolade.accoladeDescription}
                      </p>
                    </div>
                    <div className="col-span-6 md:col-span-4">
                      <p className="text-sm text-gray-500 mb-0">
                        Classification
                      </p>
                      <p className="text-base font-normal text-gray-900">
                        {accolade.accoladeClassification}
                      </p>
                    </div>
                    <div className="col-span-4 md:col-span-2">
                      <p className="text-sm text-gray-500 mb-0">Year</p>
                      <p className="text-base font-normal text-gray-900">
                        {accolade.accoladeYear}
                      </p>
                    </div>
                    <div className="col-span-2 md:col-span-1 text-right pt-3">
                      <FontAwesomeIcon
                        icon={faPencil}
                        className="justify-self-end text-gray-500 cursor-pointer"
                        onClick={() => openEditAccolade(accolade)}
                      />
                    </div>
                    <div className="col-span-2 md:col-span-1 text-right pt-3">
                      <FontAwesomeIcon
                        icon={faTrash}
                        className="justify-self-end text-red-700 cursor-pointer"
                        onClick={() => openDeleteAccoladeModal(accolade.id)}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-8 text-gray-500">
              No accolades added yet.
            </div>
          )}
        </div>
      </div>
      <AccoladeDialog
        open={isAccoladeOpen}
        onClose={() => setIsAccoladeOpen(false)}
        isAccoladeEdit={isAccoladeEdit}
        handleAccoladeSubmit={handleAccoladeSubmit}
        handleAccoladeSubmission={handleAccoladeSubmission}
        selectedType={selectedType}
        setValue={setValue}
        errors={errors}
        accoladeRegister={accoladeRegister}
        allStateOptions={allStateOptions}
        allConferenceOptions={allConferenceOptions}
        classifications={classifications}
        date={date}
        loading={loading}
        resetAccolade={resetAccolade}
      />
      <DeleteConfirmationDialog
        open={deleteAccoladeOpen}
        onClose={() => setDeleteAccoladeOpen(false)}
        title="Delete Accolade?"
        description="Are you sure you want to delete the selected accolade?"
        onConfirm={handleAccoladeDeleteConfirm}
      />
    </>
  );
}
